import React from 'react';
import {useForm} from 'react-hook-form';
import toast from 'react-hot-toast';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Button from '../../components/ui/Button';
import InputField from '../../components/ui/InputField';
import AuthLayout from '../../layout/AuthLayout';
import {pageRoutes} from '../../routes';
import {useResetPassword} from '../../api/auth';

const loginSchema = yup.object().shape({
  newPassword: yup.string().min(6).required('password is required'),
  confirmedPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Password did not match'),
});

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const resetPasswordMutation = useResetPassword();

  const {
    register,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(loginSchema),
    mode: 'all',
  });

  const handleResetPasswordSuccess = () => {
    toast.success('password reset successfully');
    reset();
    navigate('/login');
  };

  const handleFormSubmission = (values) => {
    const resetPasswordPayload = {
      ...values,
      token: searchParams.get('token'),
    };

    resetPasswordMutation.mutate(resetPasswordPayload, {
      onSuccess: handleResetPasswordSuccess,
      onError: (data) => toast.error(data.response.data.message),
    });
  };

  return (
    <>
      <h2 className="text-primary-main text-3xl font-bold text-center">
        Reset Password
      </h2>
      <form
        className="mt-10 mb-7"
        onSubmit={handleSubmit(handleFormSubmission)}
      >
        <div className="flex items-center mb-7 gap-3">
          <label className="w-1/3 text-center font-semibold">
            New Password
          </label>
          <InputField
            type="password"
            {...register('newPassword')}
            placeholder="Enter new password"
            error={errors?.newPassword?.message}
            fullWidth
          />
        </div>
        <div className="flex items-center gap-3">
          <label className="w-1/3 text-center font-semibold">
            Confirm Password
          </label>
          <InputField
            type="password"
            {...register('confirmedPassword')}
            placeholder="Verify password"
            error={errors?.confirmedPassword?.message}
            fullWidth
          />
        </div>
        <Button
          variant="flat"
          className="block ml-auto text-sm my-2 text-primary-main"
          onClick={() => navigate(pageRoutes.login)}
        >
          Go to login
        </Button>
        <Button className="block mx-auto" type="submit">
          Reset Password
        </Button>
      </form>
    </>
  );
};

export default AuthLayout(ResetPassword);
